module.exports = __webpack_public_path__ + "img/water5-1.1bba278a.jpg";